module.exports = __webpack_public_path__ + "a602345170868f752e857352af0f4630.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/beady-16.png
// module id = 1459
// module chunks = 0